import { render, staticRenderFns } from "./pageEnd.vue?vue&type=template&id=36608479&scoped=true"
import script from "./pageEnd.vue?vue&type=script&lang=js"
export * from "./pageEnd.vue?vue&type=script&lang=js"
import style0 from "./pageEnd.vue?vue&type=style&index=0&id=36608479&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36608479",
  null
  
)

export default component.exports